import { Component, Watch, Vue } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';
import AgentFrontstoreStandardLayout from '../../layout/AgentFrontstoreStandardLayout/agent.frontstore.standard.layout.vue';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';

@Component(
   {
      components: {
         'layout': AgentFrontstoreStandardLayout,
      }
   }
)
export default class AboutAgent extends Vue {
   public title: string = 'AboutAgent';

   public configs = new CommonConfig();

   public agentName = '';
   public phone = '';
   public phoneE164 = '';
   public avatarUri = '';

   public boardName = '';
   public agentTitle = '';
   public agentEmail = '';
   public agentORCode: any = null;

   public agentDesc = ``;

   public userInfo: any = undefined;

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public async onUserChanged(val: any, oldVal: any) {
      this.agentName = val.value.agentName;
      this.avatarUri = T_T.simpleDetect(val.value.agentImageUrl) ? val.value.agentImageUrl : '';
      this.agentTitle = T_T.simpleDetect(val.value.agentTitle) ? val.value.agentTitle : '';
      this.agentEmail = T_T.simpleDetect(val.value.agentEmail) ? val.value.agentEmail : '';
      this.boardName = T_T.simpleDetect(val.value.agentCompany) ? val.value.agentCompany : '';
      this.phoneE164 = T_T.simpleDetect(val.value.agentMobile) ? val.value.agentMobile : val.value.agentPhone;
      this.agentORCode = T_T.simpleDetect(val.value.agentWechatQRCode) ? val.value.agentWechatQRCode : null;
      this.agentDesc = T_T.simpleDetect(val.value.agentSlogan) ? val.value.agentSlogan : '';

      this.userInfo = T_T.simpleDetect(val.value) ? val.value : undefined;

      const apiHost = this.configs.cmisapiHost;
      const fetched = await AxiosPromise.get(`${apiHost}/ur/info?userId=${this.userInfo.userId}&ltype=1`);
      if (fetched.code === 200) {
         this.agentORCode = T_T.simpleDetect(fetched.data.agentSignatureImg) ? 'data:image/jpeg;base64,' + fetched.data.agentSignatureImg : '';
      }

      if (this.phoneE164) {
         const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
         const phoneNumber: PhoneNumber = phoneUtil.parseAndKeepRawInput(this.phoneE164);
         this.phone = phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
      }
   }
}
